
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/indonesia",
      function () {
        return require("private-next-pages/indonesia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/indonesia"])
      });
    }
  